export function formatMoney(amount: number | null | undefined, currency = 'VUV'): string {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(amount ?? 0);
}

// Event/announcement timestamps are stored as naive wall-clock values (no
// timezone suffix) so they always display as the literal digits entered,
// regardless of viewer location — do NOT pass a timeZone option here.
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  return new Date(value).toLocaleString('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

// Compact date-only display (e.g. "2 Sep 2026") for date-only values like
// Event.start_at/end_at — no time-of-day component to show.
export function formatDateShort(value: string | null | undefined): string {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatDate(value: string | Date, timezone = 'UTC'): string {
  return new Date(value).toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: timezone,
  });
}
